const PENDING_STORAGE_KEY = "passwordExpiryReminderPending";

/** Marks the password expiry dialog to be shown once, right after a login with credentials. */
export const schedulePasswordExpiryReminder = () => {
  try {
    sessionStorage.setItem(PENDING_STORAGE_KEY, "true");
  } catch {}
};

export const isPasswordExpiryReminderPending = () => {
  try {
    return sessionStorage.getItem(PENDING_STORAGE_KEY) === "true";
  } catch {
    return false;
  }
};

export const clearPasswordExpiryReminder = () => {
  try {
    sessionStorage.removeItem(PENDING_STORAGE_KEY);
  } catch {}
};
